import { Edit, Trash } from "iconsax-react";
import { Button, Table } from "reactstrap";
import { MyPropertiesTitle } from "../../../../../constants";
import { PropertiesData, PropertiesHeadData } from "../../../../../data/pages/Other";
import { dynamicImage, Image } from "../../../../../utils";

const MyProperties = () => {
  return (
    <div className="common-card">
      <div className="table-responsive property-table">
        <h4 className="dashboard-title">{MyPropertiesTitle}</h4>
        <Table>
          <thead className="table-white">
            <tr>
              {PropertiesHeadData.map((item, index) => (
                <th key={index}>{item}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {PropertiesData.map((property) => (
              <tr key={property.id}>
                <td>{property.id}</td>
                <td>
                  <div className="table-box">
                    <Image src={dynamicImage(property.image)} alt={`p-${property.id}`} className="img-fluid" />
                    <h6>{property.name}</h6>
                  </div>
                </td>
                <td>
                  <span>{property.views}</span>
                </td>
                <td>
                  <span>{property.response}</span>
                </td>
                <td>
                  <div className="d-flex align-items-center gap-3 justify-content-center">
                    <Button className="edit-btn" color="transparent">
                      <Edit className="iconsax" />
                    </Button>
                    <Button className="delete-btn" color="transparent">
                      <Trash className="iconsax" />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default MyProperties;
